import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {mapResponseEntity} from '@toolify/client/src/modules/api/singletons/mapResponseEntity'
import {mapResponseResourcePath} from '@toolify/client/src/modules/api/singletons/mapResponseResourcePath'
import {
  NotificationPayloadMapperStrategyMap,
} from '@toolify/client/src/modules/api/notificationPayloadMappers/maps/NotificationPayloadMapperStrategyMap'
import {
  INotificationPayloadMapperStrategy,
} from '@toolify/client/src/modules/api/notificationPayloadMappers/types/INotificationPayloadMapperStrategy'
import {
  INotificationInterfacesByTypeMap,
} from '@toolify/server/src/services/NotificationService/types/INotificationInterfacesByTypeMap'
function mapNotificationPayload<T extends NotificationType>(
  type: T,
  payload: IToJson<INotificationInterfacesByTypeMap[T]['payload']>,
): INotificationInterfacesByTypeMap[T]['payload'] {
  const strategy = NotificationPayloadMapperStrategyMap[type] as INotificationPayloadMapperStrategy<T> | undefined
  /**
   * A notification type the client does not know a mapper for must not take the whole feed down —
   * a server ahead of a cached client build is normal. Pass the payload through, as this did before
   * the strategy map was introduced.
   */
  if(!strategy) {
    return payload as INotificationInterfacesByTypeMap[T]['payload']
  }
  return strategy.mapPayload(payload)
}

export function mapNotificationResponseInstance(
  notification: IToJson<INotificationResponseInstance<NotificationType>>,
): INotificationResponseInstance<NotificationType> {
  return {
    ...notification,
    resourcePath: mapResponseResourcePath(notification.resourcePath),
    authorEntity: mapResponseEntity(notification.authorEntity),
    viaEntity: notification.viaEntity ? mapResponseEntity(notification.viaEntity) : null,
    payload: mapNotificationPayload(notification.type, notification.payload),
    createdAt: notification.createdAt ? new Date(notification.createdAt) : null,
    readAt: notification.readAt ? new Date(notification.readAt) : null,
    seenAt: notification.seenAt ? new Date(notification.seenAt) : null,
  }
}
